import { AppAreaConfig } from '@/funnels/@types'
import { EU_REGION_COUNTRIES_REGEX } from '@/helpers/constants'

const appAreaConfig: AppAreaConfig = {
	appArea: 'male',
	landing: {
		ids: ['loader-m'],
		route: {
			path: '/m',
			name: 'male-funnel',
		},
	},
	funnel: {
		id: 'ob-male-funnel',
		route: {
			path: '/m/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'male-survey',
		},
		slug: 'male',
		locale: [
			'en',
			'de-DE',
			'fr-FR',
			'tr',
			'sv',
			'pl',
			'pt-BR',
			'it-IT',
			'es-ES',
			'es-419',
			'da',
			'nb',
			'nl',
			'ar',
			'ja',
		],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-m',
		overrides: [
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-m-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-m'],
	},
}

export default appAreaConfig
